import { render } from "./NoAccess.vue?vue&type=template&id=95d3fc60&ts=true"
import script from "./NoAccess.vue?vue&type=script&lang=ts"
export * from "./NoAccess.vue?vue&type=script&lang=ts"

import "./NoAccess.vue?vue&type=style&index=0&id=95d3fc60&lang=scss"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__